import { GoogleAnalytics } from '@next/third-parties/google'
import Script from 'next/script'
import { LinkedInInsightTag } from 'nextjs-linkedin-insight-tag'

export interface TrackingCodes {
	googleTagId?: string
	linkedinPartnerId?: string
	metaPixelId?: string
}

export const TrackPage: React.FC<{ trackingCodes: TrackingCodes }> = ({
	trackingCodes,
}) => {
	return (
		<>
			{trackingCodes.googleTagId && (
				<GoogleAnalytics gaId={trackingCodes.googleTagId} />
			)}
			{trackingCodes.metaPixelId && (
				<FacebookPixelCode metaPixelId={trackingCodes.metaPixelId} />
			)}
			{trackingCodes.linkedinPartnerId && (
				<LinkedInInsightTag partnerId={trackingCodes.linkedinPartnerId} />
			)}
		</>
	)
}

export const FacebookPixelCode: React.FC<{ metaPixelId: string }> = ({
	metaPixelId,
}) => {
	return (
		<>
			<Script id="meta-pixel" strategy="afterInteractive">
				{`
              !function(f,b,e,v,n,t,s)
              {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
              n.callMethod.apply(n,arguments):n.queue.push(arguments)};
              if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
              n.queue=[];t=b.createElement(e);t.async=!0;
              t.src=v;s=b.getElementsByTagName(e)[0];
              s.parentNode.insertBefore(t,s)}(window, document,'script',
              'https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${metaPixelId}');
              fbq('track', 'PageView');
            `}
			</Script>
			<noscript>
				<img
					height="1"
					width="1"
					alt=""
					style={{ display: 'none' }}
					src={`https://www.facebook.com/tr?id=${metaPixelId}&ev=PageView&noscript=1`}
				/>
			</noscript>
		</>
	)
}
